
export const curatedUrl = "/recommendations";
